import { useCallback, useEffect, useMemo, useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import type { TeamReportRowType } from '@econtractor/types';
import * as apiReport from 'api/apiReports';
import { useToast } from 'context/ToastContext';
import ESpinner from 'components/others/Spinner';
import type { ReportDateFilterState } from '../helper/reportObjectsStorage';
import {
    loadReportTeamsFilters,
    saveReportTeamsFilters,
} from '../helper/reportTeamsStorage';
import ReportDate from '../ReportDate';
import ReportTeamTable from './ReportTeamsTable';

const ReportTeam = () => {
    const { t } = useTranslation(['Reports']);
    const { showToast } = useToast();
    const savedFilters = useMemo(() => loadReportTeamsFilters(), []);

    const [teamsList, setTeamsList] = useState<TeamReportRowType[] | null>(null);
    const [isReporting, setIsReporting] = useState(false);
    const [dates, setDates] = useState<[number, number] | null>(savedFilters.dates);
    const [dateFilter, setDateFilter] = useState<ReportDateFilterState>({
        period: savedFilters.period,
        dates: savedFilters.dates,
        customRange: savedFilters.customRange,
    });

    const persistFilters = useCallback(
        (filter: ReportDateFilterState) => {
            saveReportTeamsFilters(filter);
        },
        [],
    );

    const handleDateFilterChange = (filter: ReportDateFilterState) => {
        setDateFilter(filter);
        setDates(filter.dates);
        persistFilters(filter);
    };

    const fetchReport = async () => {
        if (!dates?.[0] || !dates?.[1]) return false;
        setIsReporting(true);
        setTeamsList(null);
        const resRep = await apiReport.get4Teams(dates[0], dates[1]);
        if (!resRep) showToast(t('common:messError'), 'danger');
        setTeamsList(resRep?.teams ?? null);
        setIsReporting(false);
    };

    useEffect(() => {
        fetchReport();
    }, [dates?.[0], dates?.[1]]);

    return (
        <Row>
            <Col className="col-sticky" sm={12}>
                <div className="w-100 d-sm-flex pt-1 justify-content-between align-items-start gap-2">
                    <div className="flex-shrink-0">
                        <h4 className="p-0 m-0 mb-0 me-2 text-nowrap">{t('common:SideBarUl.itemRepostsTeams')}</h4>
                    </div>
                    <div className="mt-2 mt-sm-0 mb-2 page-toolbar-actions">
                        <ReportDate
                            setDates={setDates}
                            disabled={isReporting}
                            initialFilter={dateFilter}
                            onFilterChange={handleDateFilterChange}
                        />
                    </div>
                </div>
            </Col>

            <Col sm={12}>
                <div className="px-0">
                        {teamsList ? <ReportTeamTable teamList={teamsList} /> : <ESpinner />}
                    
                </div>
            </Col>
        </Row>
    );
};

export default ReportTeam;
